import 'devextreme/dist/css/dx.light.css';
import("./bootstrap");
